// Generated by CoffeeScript 1.12.6

/*
Observable
==========

`Observable` allows for observing arrays, functions, and objects.

Function dependencies are automagically observed.

Standard array methods are proxied through to the underlying array.
 */

(function() {
  "use strict";
  var Observable, PROXY_LENGTH, copy, extend, last, magicDependency, noop, remove, tryCallWithFinallyPop,
    slice = [].slice;

  module.exports = Observable = function(value, context) {
    var changed, fn, listeners, notify, self;
    if (typeof (value != null ? value.observe : void 0) === "function") {
      return value;
    }
    listeners = [];
    notify = function(newValue) {
      return copy(listeners).forEach(function(listener) {
        return listener(newValue);
      });
    };
    if (typeof value === 'function') {
      fn = value;
      self = function() {
        magicDependency(self);
        return value;
      };
      self.releaseDependencies = function() {
        var ref;
        return (ref = self._observableDependencies) != null ? ref.forEach(function(observable) {
          return observable.stopObserving(changed);
        }) : void 0;
      };
      changed = function() {
        var observableDependencies;
        observableDependencies = new Set;
        value = tryCallWithFinallyPop(observableDependencies, fn, context);
        self.releaseDependencies();
        self._observableDependencies = observableDependencies;
        observableDependencies.forEach(function(observable) {
          return observable.observe(changed);
        });
        return notify(value);
      };
      changed();
    } else {
      self = function(newValue) {
        if (arguments.length > 0) {
          if (value !== newValue) {
            value = newValue;
            notify(newValue);
          }
        } else {
          magicDependency(self);
        }
        return value;
      };
      self.releaseDependencies = noop;
    }
    if (Array.isArray(value)) {
      ["concat", "every", "filter", "forEach", "indexOf", "join", "lastIndexOf", "map", "reduce", "reduceRight", "slice", "some"].forEach(function(method) {
        return self[method] = function() {
          var args;
          args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
          magicDependency(self);
          return value[method].apply(value, args);
        };
      });
      ["pop", "push", "reverse", "shift", "splice", "sort", "unshift"].forEach(function(method) {
        return self[method] = function() {
          var args, returnValue;
          args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
          returnValue = value[method].apply(value, args);
          notify(value);
          return returnValue;
        };
      });
      if (PROXY_LENGTH) {
        Object.defineProperty(self, 'length', {
          get: function() {
            magicDependency(self);
            return value.length;
          },
          set: function(length) {
            var returnValue;
            returnValue = value.length = length;
            notify(value);
            return returnValue;
          }
        });
      }
      extend(self, {
        remove: function(object) {
          var index, returnValue;
          index = value.indexOf(object);
          if (index >= 0) {
            returnValue = value.splice(index, 1)[0];
            notify(value);
            return returnValue;
          }
        },
        get: function(index) {
          magicDependency(self);
          return value[index];
        },
        first: function() {
          magicDependency(self);
          return value[0];
        },
        last: function() {
          magicDependency(self);
          return value[value.length - 1];
        },
        size: function() {
          magicDependency(self);
          return value.length;
        }
      });
    }
    extend(self, {
      listeners: listeners,
      observe: function(listener) {
        return listeners.push(listener);
      },
      stopObserving: function(fn) {
        return remove(listeners, fn);
      },
      toggle: function() {
        return self(!value);
      },
      increment: function(n) {
        if (n == null) {
          n = 1;
        }
        return self(value + n);
      },
      decrement: function(n) {
        if (n == null) {
          n = 1;
        }
        return self(value - n);
      },
      toString: function() {
        return "Observable(" + value + ")";
      }
    });
    return self;
  };

  extend = Object.assign;

  global.OBSERVABLE_ROOT_HACK = [];

  magicDependency = function(self) {
    var observerSet;
    observerSet = last(global.OBSERVABLE_ROOT_HACK);
    if (observerSet) {
      return observerSet.add(self);
    }
  };

  tryCallWithFinallyPop = function(observableDependencies, fn, context) {
    global.OBSERVABLE_ROOT_HACK.push(observableDependencies);
    try {
      return fn.call(context);
    } finally {
      global.OBSERVABLE_ROOT_HACK.pop();
    }
  };

  remove = function(array, value) {
    var index;
    index = array.indexOf(value);
    if (index >= 0) {
      return array.splice(index, 1)[0];
    }
  };

  copy = function(array) {
    return array.concat([]);
  };

  last = function(array) {
    return array[array.length - 1];
  };

  noop = function() {};

  try {
    Object.defineProperty((function() {}), 'length', {
      get: noop,
      set: noop
    });
    PROXY_LENGTH = true;
  } catch (error) {
    PROXY_LENGTH = false;
  }

}).call(this);
